<template>
    <div id="telethonbroadcast">
        <main class="main">
        	<pre></pre>
			<div id="radical-broadcast">
				<div class="rb-video-wrap">

					<iframe class="rb-video" :src="broadcastUrl.url" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
				</div>
			</div>
            


		
			<article v-if="prismicLoaded" class="tb-tickers">

				<template v-for="(ticker, index) of tickers.slice(0,2)">
					<Ticker :ticker="ticker" :index="index" :key="index" />
				</template>
			
			</article>

			

			<article v-if="prismicLoaded" class="tb-tickers">

				<template v-for="(ticker, index) of tickers.slice(2, 4)">
					<Ticker :ticker="ticker" :index="index" :key="index" />
				</template>
			
			</article>

			<TVTestCard />

			<article class="do-pr-container grid-container c2" v-if="prismicLoaded">
				<div class="donation-info new-blue wrap">
					<div class="donate-container">
						<img :src="require('../assets/img/performa-logo.svg')" class="performa-logo" />
						<prismic-rich-text :field="donateBanner.title" />
						<!-- <span class="date">November 18, 2020 <br /> 2PM-10PM EST</span> -->
						<prismic-rich-text class="date" :field="donateBanner.telethonDate"  />
						<hr style="margin: 1em auto 0.5em;"/>
						<hr style="margin: 0.5em auto;"/>
						<hr style="margin: 0.5em auto 1em;"/>
						<div class="fine-details">
							<prismic-rich-text :field="donateBanner.textInfo" />
							<prismic-rich-text :field="donateBanner.callInfo" />
						</div>
 						<div class="btn donate-btn">
							 <a :href="donateBanner.buttonLink.url" target="_blank">{{ donateBanner.buttonLinkText }}</a>
						</div>
						<prismic-rich-text class="additional-info" :field="donateBanner.additionalInfo" />
						<div class="bubbles noselect">
							<div class="bubble pink-bubble">
								<span> {{ donateBanner.pinkBubbleText }} </span>
							</div>
							<div class="bubble yellow-bubble">
								<span>{{ donateBanner.yellowBubbleText }}</span>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="black wrap">
						<prismic-rich-text :field="program.title" />
						<prismic-rich-text class="section-description" :field="program.description" />
					</div>
					<div class="telethon-program wrap">
						<div class="tb-section" v-for="(expander, index) of program.expanders" :key="index">
							<h4 :class="hour === expander.primary.program_schedule_title[0] ? 'new-green' : null">
								{{ expander.primary.program_schedule_title }}
							</h4>
							<ul>
								<TBExpander v-for="(item, index) of expander.items" :key="item.video_title + index" :currentVideo="isCurrent" :video="item" />
							</ul>
						</div>
					</div>
				</div>
			</article>
			<article class="shop-container shop wrap">

				<div>

					<prismic-rich-text class="shop-header" :field="editions.title" /> 
					<prismic-rich-text class="section-description" :field="editions.introText" /> 

				</div>

				<div class="grid-container c4 products-container">
					<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/barbara-kruger-don-t-be-a-jerk-skate-deck"><img src="https://assets.bigcartel.com/product_images/317744706/Kruger+Stake+Deck.jpg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$5,000<br></strong><a href="https://performa.bigcartel.com/product/barbara-kruger-don-t-be-a-jerk-skate-deck">Barbara Kruger, "Don't Be A Jerk" Skate Deck</a><br>(5 available)</p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/barbara-kruger-nature-culture-vase"><img src="https://assets.bigcartel.com/product_images/317745018/Kruger+Vase.jpeg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$2,000<br></strong><a href="https://performa.bigcartel.com/product/barbara-kruger-nature-culture-vase">Barbara Kruger, "NATURE / CULTURE" Vase</a><br>(10 available)</p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/korakrit-arunanondchai-mother-pillow-2020"><img src="https://assets.bigcartel.com/product_images/318024963/Performa2066.jpg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$1,500<br></strong><a href="https://performa.bigcartel.com/product/korakrit-arunanondchai-mother-pillow-2020">Korakrit Arunanondchai, "Mother Pillow"</a></p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/sara-cwynar-untitled-2021"><img src="https://assets.bigcartel.com/product_images/317962086/Flat_Performa+Edition+Cwynar.jpg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$275<br></strong><a href="https://performa.bigcartel.com/product/sara-cwynar-untitled-2021">Sara Cwynar, Untitled, 2021</a></p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/ericka-beckman-beanstalk-lady-2021"><img src="https://assets.bigcartel.com/product_images/317967750/Ericka+Beckman_+Beanstalk.jpg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$275<br></strong><a href="https://performa.bigcartel.com/product/ericka-beckman-beanstalk-lady-2021">Ericka Beckman, "Beanstalk Lady", 2021</a><br>(10 available)</p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/six-performa-biennial-publications"><img src="https://assets.bigcartel.com/product_images/317745555/Performa+05+Pub.jpeg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$500<br></strong><a href="https://performa.bigcartel.com/product/six-performa-biennial-publications">Collection of Six Performa Biennial publications</a></p>
</div>



<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/collection-of-signed-roselee-goldberg-publications"><img src="https://assets.bigcartel.com/product_images/317745645/RLG+Pub+2.jpeg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$250<br></strong><a href="https://performa.bigcartel.com/product/collection-of-signed-roselee-goldberg-publications">Collection of Two Signed Performance Art Publications by RoseLee Goldberg</a></p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/derrick-adams-go-stand-next-to-the-mountain-signed-vinyl-record"><img src="https://assets.bigcartel.com/product_images/317745957/Derrick+Adams+Go+Stand+Next+to+the+Mountain+LP.jpeg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$150<br></strong><a href="https://performa.bigcartel.com/product/derrick-adams-go-stand-next-to-the-mountain-signed-vinyl-record">Derrick Adams, "Go Stand Next to the Mountain" signed vinyl record</a><br>(25 available) <br><br></p>
</div>



<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/still-here-moments-in-isolation"><img src="https://assets.bigcartel.com/product_images/317745900/Still+Here+%7C+Moments+in+Isolation.jpeg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$125<br></strong><a href="https://performa.bigcartel.com/product/still-here-moments-in-isolation">"Still Here | Moments in Isolation" Publication by Mafalda Millies &amp; Roya Sachs</a></p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/on-the-town-a-performa-compendium-2016-2021"><img src="https://assets.bigcartel.com/product_images/318026058/On+The+Town.jpg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$100<br></strong><a href="https://performa.bigcartel.com/product/on-the-town-a-performa-compendium-2016-2021">"On the Town: A Performa Compendium 2016–2021" Performa Publication</a></p>
</div>



<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/performa-2021-biennial-hoodies"><img src="https://assets.bigcartel.com/product_images/317922450/hoodie.JPG?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$75<br></strong><a href="https://performa.bigcartel.com/product/performa-2021-biennial-hoodies">Performa 2021 Biennial Hoodies</a></p>
</div>

<div class="product-card">
	<div class="pgi">
		<a href="https://performa.bigcartel.com/product/barbara-kruger-mta-metrocards"><img src="https://assets.bigcartel.com/product_images/317745096/Kruger+Metrocard.jpg?auto=format&fit=max&h=1000&w=1000" class="product-card-image" /></a>
	</div>
	<p><strong>$50<br></strong><a href="https://performa.bigcartel.com/product/barbara-kruger-mta-metrocards">Barbara Kruger MTA MetroCards</a><br>(20 sets available) </p>
</div>	
</div>
			</article>
			<TVTestCard />

        </main>
    </div>

</template>


<script>	
import RadicalBroadcast from '../components/RadicalBroadcast.vue'
import FeaturedBanner from '../components/FeaturedBanner.vue'
import Carousel from '../components/Carousel.vue'
import FeaturedArticle from '../components/FeaturedArticle.vue'
import Livestream from '../components/Livestream.vue'
import TBExpander from '../components/telethon-broadcast/TBExpander.vue';
import Ticker from '../components/telethon-broadcast/Ticker.vue';
import TVTestCard from '../components/telethon-broadcast/TVTestCard';


import config from '../../config.js';
import ShopifyClient from '../services/ShopifyClient'

import prismicDOM from 'prismic-dom'
import moment from 'moment'

const toggleClass = function (target, addRemoveClass, className) {
  if (addRemoveClass === 'addClass') {
    target.classList.add(className);
  } else {
    target.classList.remove(className);
  }
}

export default {
	name: 'Homepage',

  	components: {
		RadicalBroadcast,
	  	FeaturedBanner,
	  	Carousel,
		Livestream,
		TBExpander,
		Ticker,
		TVTestCard
	},

	computed: {
		isCurrent() {
			let date = moment().format('DD')
			let now = parseInt(moment().format('hmm'));
			this.hour = now[0];
			const videosInProgram = [];
			const videoStartTimes = []

			for (let expander of this.program.expanders) {
				
				for (let item of expander.items) {
					if (item.video_start_time === null) {
						continue
					} else {
						const videoStartTimeArr = item.video_start_time.split(':');
						if (videoStartTimeArr.length < 2) {
							continue
						} else {
							const timeToPushIntoArray = videoStartTimeArr[0] + videoStartTimeArr[1];
							videoStartTimes.push(parseInt(timeToPushIntoArray));
							videosInProgram.push(item);
						}
						
					}
				}
			}

			let i = 0;
			while (i < videoStartTimes.length) {
				if (date === '18' && now >= videoStartTimes[i] && now < videoStartTimes[i + 1]) {
					return videosInProgram[i];
				} 
				i++;
			}
			return false;
		},

	},
	  
  	data () {
		return {
			prismicLoaded: false,

			donateBanner: {
				title: '',
				telethonDate: '',
				callInfo: '',
				textInfo: '',
				pinkBubbleText: '',
				yellowBubbleText: '',
				buttonLink: '',
				buttonLinkText: '',
				additionalInfo: ''
			},
			broadcastUrl: {
				url: ''
			},
			editions: {
				title: '',
				introText: ''
			},
			program: {
				title: '',
				description: '',
				expanders: []
			},
			tickers: [
				{
				tickerBackground: '',
				tickerText: []
				}
			],
			credits: [],
			products: [],
			hour: '',
			soundOff: true,
			countDown: {
				days: '',
				hours: '',
				minutes: '',
				seconds: ''
			}
		}
	},
	  
 
   	methods: {
	
		toggleBodyClass(addRemoveClass, className) {
	    	const el = document.body;
	    	if (addRemoveClass === 'addClass') {
	      		el.classList.add(className);
	    	} else {
	      		el.classList.remove(className);
	    	}
		  },
		  
	  	showEvents() {
			this.eventsExpanded = true
		},

		async getPrismicContent() {

			const res = await this.$prismic.client.getSingle('telethon')
			// console.log(res.data)

			// let timer;
			
			// timer = window.setInterval(() => {
			// 	// res.data.telethon_start_time
			// 	const eventDate = moment(res.data.telethon_start_time);
			
			// 	const now = moment();
				
			// 	const countdown = moment.duration(eventDate.diff(now))
				
			// 	const days = countdown.days();
			// 	const hours = countdown.hours();
			// 	const minutes = countdown.minutes();
			// 	const seconds = countdown.seconds();
				

			// 	this.countDown = { days, hours, minutes, seconds };

			// 	if (this.countDown.days === 0 && this.countDown.hours === 0 && this.countDown.minutes === 0 && this.countDown.minutes === 0 && this.countDown.seconds === 0) {
			// 		window.clearInterval(timer);
			// 	}

			// }, 1000);
			
			


			
			this.donateBanner = {
				title: res.data.donate_title,
				telethonDate: res.data.telethon_date_and_time,
				callInfo: res.data.donate_call_info,
				textInfo: res.data.donate_text_info,
				pinkBubbleText: res.data.pink_bubble_text,
				yellowBubbleText: res.data.yellow_bubble_text,
				buttonLink: res.data.donate_button_link,
				buttonLinkText: res.data.donate_button_link_text,
				additionalInfo: res.data.additional_information
			}

			this.broadcastUrl = {
				url: res.data.broadcast_vimeo_url
			}

			this.tickers = res.data.body;

			this.editions = {
				title: res.data.editions_title,
				introText: res.data.editions_intro_text
			}

			this.program = {
				title: res.data.program_title,
				description: res.data.program_description,
				expanders: res.data.body1
			}

			this.credits = res.data.body3;

			this.prismicLoaded = true;
		},

		redirectToCheckout (product) {

			if (!product.availableForSale) return false;

			const variantId = product.variants[0].id;
			this.shopifyClient.createCheckoutId(successResponse => {
          
          		console.log('success');


        	}, errorResponse => {
            	console.log('error')
        	},
			variantId);
			
		},

		videoSoundToggle () {
			this.soundOff = !this.soundOff;
		},

		artistName (title) {
			const name = title;
			return name ? name : title
			// return title.split(',')[1]
		},

		configureTime (time) {
			return time.length === 1 ? '0' + time : time;
		},

		redirectToProductDetailPage (product) {
			let url = "https://performa-artist-editions.myshopify.com/products/";
			switch (product.title) {
				case "Barbara Kruger, Untitled (Vase)":
					url += 'barbara-kruger-vase';
					break;
				case "Cindy Sherman, Untitled (Vanity Mirror)":
					url += 'cindy-sherman-mirror';
					break;
				case "Kia LaBeija x Taína Larot, Ring of Fire; The List is Endless":
					url += 'kia-labeija-art-demands';
					break;
				case "Kia LaBeija, December 1st":
					url += 'kia-labieja-december-1st';
					break;
				case "Kia LaBeija, Untitled (The Spirals that lead to Nowhere)":
					url += 'kia-labeija-duet';
					break;
				case "Korakrit Arunanondchai, Mother Pillow":
					url += 'korakrit-arunondchai-body-pillow';
					break;
				case "Laurie Simmons X David Bers Architects, FlashCube":
					url += 'flashcube-laurie-simmons-x-david-bers';
					break;
				case "Michèle Lamy X Katerina Jebb, Untitled (Plateau / Tray)":
					url += 'michele-lamy-tray';
					break;
				default:
					url += 'all-editions';
					break;
				
			}
			window.open(url, '_blank');
		}

	},

	async created () {
		await this.getPrismicContent();
		this.updateToday = moment().format('MM•D•YYYY');
	},
	  
  	async mounted() {
		
		
		this.toggleBodyClass('addClass', 'template-index');
		setTimeout(function() {
	  		toggleClass(document.body, 'addClass', 'loaded');
		}, 500);

		this.shopifyClient = new ShopifyClient(config.shopifyDomain, config.shopifyToken);

		await this.shopifyClient.allProducts(products => {
			this.products = products;
		});
  	},

  	destroyed() {
		this.toggleBodyClass('removeClass', 'template-index');
  	}
}
</script>

<style>


	 @keyframes smile {
	 0% {
	transform:rotate(-10deg);
	}
	 50% {
	transform:rotate(10deg);
	}
	 100% {
	transform:rotate(-10deg);
	}
	}

/***** global page styles *****/  

p.name{
	margin-top: 0px;
	margin-bottom: 0px;
	width: 75%;
}

:root {
	--new-blue: #0200FF;
	--green: #00FF00;
}

.wrap-x {
	padding: 0px 64px;
}

#telethonbroadcast strong {
	color: var(--green);
	font-weight: normal !important;
}

#telethonbroadcast .shop strong{
	color: black;
}


#telethonbroadcast strong em {
	font-style: normal !important;
    text-shadow: 5px 0px 16px #00FF00;
}

.new-blue {
	background-color: var(--new-blue);
	border-right: 2px solid white;
}

/* COUNTDOWN */

.countdown-container {
	width: 100vw; 
	height: 80vh; 
	color: green;
}

.countdown {
	position: absolute; 
	top: 40%; left:50%;
	transform:translate(-50%, -50%); 
	font-size:3vmax;
	font-family: 'Block'; 
	width: 100%; 
	text-align: center; 
	margin: 0; 
	padding: 0
}


/****  tickers  ****/

.tb-tickers{
	padding-top: 16px;
	padding-bottom: 16px;
	background-color: #FFFF00;
}

.broadcast-ticker {
	font-size: 2vw !important;
	padding: 16px 0;
	background-color: transparent !important;
}

.broadcast-ticker:last-child {
	padding-top: 0;
}


.broadcast-ticker-item:before {
	content: '•';
	padding-right: 16px;
	padding-left: 8px;
}

.broadcast-ticker-item a{
	background-color: black;
	padding: 8px 16px;
	border-radius: 22px;
	display: inline-block !important;
	color: #00FF00 !important;
	font-family: 'Helvetica-Rounded';
	font-weight: normal !Important;
	font-size: 2vmax !important;
	position: relative;
}

.broadcast-ticker-item a:hover{
	background-color: white !important;

	color: black !important;
}

/* DONATE PROGRAM CONTAINER */

.do-pr-container {
	border-top: 2px solid white;
	border-bottom: 2px solid white;
	font-family: 'Helvetica-Rounded';
	color: white;
	max-width: 100vw;  
    height: 100%; 
}


.do-pr-container div h1, .do-pr-container h2, .do-pr-container h3 {
	color: var(--green);
}

.section-description {
	margin-top: 32px; 
}

/* DONATION STYLES */

.donation-info {
	width: 100%;
	height: 100vh;
	position: sticky;
    position: -webkit-sticky;
	top: 0;	
	z-index: 99;
}

.donate-container {
	height: 100%;
	overflow:hidden;

	display: flex;
	flex-direction: column;
	align-content: center;
	align-items: center;
	justify-content: center;
}

.donate-container .performa-logo {
	display: none;
	position: absolute;
	top: -64px;
	left: -64px;
}


.donate-container h1, .donate-container h2, .donate-container h3 {
	margin: 32px 0px;
	font-size: 3vw;
	line-height: 1;
	text-align: center;
}

.donate-container .date {
	text-align: center;
	font-size: 1.5vw;
	
}

.donate-container .date p {
	margin: 0px !important;
}

.donate-container h1 {
	margin: 8px 0px;
}

.donate-container div p {
	margin: 0px 0px;
	font-size: 2vw;
}

.donate-container hr {
	height: 3px;
	width: 100%;
	background: var(--green);
	border: none;
	margin: 16px 0px;
}

.donate-btn {
	margin-top: 16px !important;
	background: var(--green);
	padding: 16px 48px;
	width: 100%;
	text-align: center;
	cursor: pointer;
	border: 3px solid #3CFF00;
	box-shadow: 0 0 16px 1px #00FF00;
	transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
	border-radius: 48px;
}

.donate-btn a {
	color: black;
}

.donate-btn:hover{
	background: black;
	border: 3px solid black;
	box-shadow: 0 0 16px 1px #FFF;
}

.donate-btn:hover a{
	color: white;
}

.donate-container .additional-info p {
	margin-top: 24px;
	font-size: 14px;
}

.donate-container .bubbles .bubble {
	position: absolute;
	width: 120px;
	height: 120px;
	text-align: center;
	border-radius: 50%;
	display: flex;
	align-items: center;
}

.pink-bubble {
	background-color: #FF00FF;
	top: 25%;
	right: -96px;
	border: 3px solid #FF00FF;
	box-shadow: 0 0 16px 1px #FF00FF;
	animation: smile 6s ease-in-out infinite;
}  

.yellow-bubble {
	background-color: #FFFF00;
	top: 35%;
	right: -72px;
	border: 3px solid #FFFF00;
	box-shadow: 0 0 16px 1px #FFFF00;
	animation: smile 4s ease-in-out infinite;
}

.pink-bubble span, .yellow-bubble span {
	color: black;
	padding: 16px;
	font-size: 12px;
	line-height: 1;

}

.pink-bubble span {
	transform: rotate(20deg);
}

.yellow-bubble span {
	transform: rotate(-20deg);
}

/* PROGRAM */

.do-pr-container .black {
	background-color: black;
}

.telethon-program {
	padding-top: 48px;
	color: black;
	background: #fff;
}

.tb-section {
	margin-bottom: 32px;
}

.telethon-program h4 {
	font-size: 2vw;
	line-height: 1;
	margin: 2em 0 1em;

}
.telethon-program h4:after{
	content: '↘';
	font-family: monospace;
	position: relative;
	bottom: 4px;
}

.new-green {
	color: var(--green);
}


/* SHOP */

.shop-container {
	color: black;
	padding-bottom: 48px;
	font-family: "Helvetica-Rounded";
	border-bottom: 2px solid white;
}

.shop-container h2 {
	color: black !important;
}

.shop-container p {
	font-size: 1.5vw;
	margin: 0px;	
}

.shop-container p:first-child {
	margin-bottom: 8px;
}

.shop {
	background: #00FFFF;
}

.products-container.grid-container.c4 {
	margin-top: 46px;
	grid-template-columns: 1fr 25%;
}

.products-container.grid-container.c4 {
	margin-top: 46px;
	grid-template-columns: 25% 25% 25% 25%;
}

.product-card {
	margin: 15px 0px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 32px 16px 0px;
	position: relative;
}

.product-card h3 {
	font-size: 16px;
	height: 48px;
	text-align: center;
}

.product-card-image {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0; left: 0;
	object-fit: cover;
	object-position: top center;
	margin: 0 auto;
	border: 1px black solid;
	
}



.tb-btn {
	padding: 16px 32px;
	text-transform: uppercase;
	text-align: center;
	font-family: 'Helvetica-Rounded';
	background-color: #000;
	border: 3px solid #000;
    border-radius: 71px;
	color: #FFF;
	transition: background-color 300ms cubic-bezier(0.57, 0.06, 0.05, 0.95);
	font-size: 14px;
}

.tb-btn:hover {
	cursor: pointer;
	background-color: white;
	color: black;
}


.sold-out {
	opacity: 0.8;
	position: relative;
	z-index: 200;
} 



/* SUPPORTERS */

.tb-credits {
	background: #FF00FF;;
	color: white;
	padding-bottom: 64px;
	font-family: "Helvetica-Rounded";
}

.credit-list {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
} 

.credits-title {
	padding-bottom: 0;
	margin-bottom: 32px;
}

.credits-title h2 {
	font-size: 2.8vw;
	color: black;
	position: relative;
	display: inline;
	padding-bottom: 16px;
}

.credits-title h2:after {
	position: absolute;
	bottom: 0;
	left: 0;
	display: block;
	content: '';
	height: 2px;
	border-bottom: 2px solid black;
	width: 100%;
}

.no-border {
	border: none !important;
}

.credit-card {
	margin: 46px 0px;
	font-family: 'Helvetica-Rounded';
}


.credit {
	line-height: 1;
	margin-bottom: 8px;
	word-break: break-word;
	width: 70%;
}

.tb-footer{
	max-width:768px;
	margin: 0 auto;
}

.tb-footer .img-container {
	width: 100%;
	height: 0px;
	padding-bottom: 80%;
	position: relative;

}

.tb-footer .img-container a img {
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0px; left: 0px; 
	object-fit: contain;
	object-position: center center;
}


 @media screen and (max-height: 500px) and (min-width: 768px) {
	 .donate-container {
		 margin-top: 0px;
	 }
 }

@media (max-width: 968px) {
	.product-card h3 {
		height: 64px;
	}

	.tb-btn {
		padding: 16px 32px;
		font-size: 8px;
	}

	.tb-footer.grid-container.c3 {
		grid-template-columns: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tb-footer .img-container {
		padding-bottom: 20%;
		display: flex;
		align-content: center;
		justify-content: center;
		left: 20px;
	}

	.tb-footer .img-container a img { 
		margin: 0 auto;
		width: 100%;
	}
}

@media (max-width: 64em) {
	.tb-credits .grid-container.c3 {
		grid-template-columns: 50% 50% !important;
	}
}

@media (min-width: 64em) {
	.shop-header, .shop-container .section-description{
		width: 50%;
		margin-left: auto;
		margin-right: auto;
	}

	.countdown{
		font-size: 6vw;
	}

	.donate-container .additional-info p {
		font-size: 12px;}

	.product-card-image:hover{
		/*transform:scale(1.125);*/
	}
}

@media (max-width: 968px) {
	.donate-container .additional-info p {
		font-size: 1vw;
	}
}

@media (max-width: 768px) {
	#telethonbroadcast {
		overflow-x: hidden !important;
	}

	.broadcast-ticker {
		font-size: 3.5vw !important;

	}

	.products-container.grid-container.c4 {
		margin-top: 46px;
		grid-template-columns: 100%;
	}

	.product-card {
		margin: 15px 0px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 32px 16px;
		position: relative;
	}

	.product-card h3 {
		font-size: 24px;
	}

	.product-card-image {
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0; left: 0;
		object-fit: cover;
		object-position: top center;
		/* height: auto; */
		margin: 0 auto;
	}

	.product-card-image:hover {
		opacity: 0.9;
	}

	.tb-btn {
		padding: 16px 72px;
		font-size: 16px;
	}

	.do-pr-container {
		border-top: none;
		border-bottom: none;
	}

	.do-pr-container.grid-container.c2 {
		grid-template-columns: 100%;
	}

	.donation-info {
		position: relative;
		height: 100%;
		border-right: none !important;
		border-top: 2px solid white;
		border-bottom: 2px solid white;
		padding-top: 64px;
		padding-bottom: 64px;
	}

	.donate-container {
		margin-top: 32px;
	}

	.donate-container div p {
		margin: 0px 0px;
		font-size: 18px;
	}

	.donate-container .additional-info p {
		font-size: 16px;
	}

	.bubble {
		display: none !important;
	}

	.do-pr-container h1, .do-pr-container h2 {
		font-size: 36px;
	}

	.section-description p {
		font-size: 16px;
	}

	.telethon-program .tb-section h4 {
		font-size: 20px;
		margin: 16px 0px 48px;
		hyphens: none;
	}

	.telethon-program .tb-section {
		margin-bottom: 48px;
	}

	.telethon-program .tb-section ul li {
		font-size: 16px;
	}

	.telethon-program .tb-section ul li .tb-video-description p {
		font-size: 14px;
	}

	.credits-title h2 {
		font-size: 24px;
	}

	.tb-credits .grid-container.c3 {
		padding: 32px !important;
		grid-template-columns: 100% !important;
	}

	.credit {
		font-size: 18px;
		padding: 0;
		margin-bottom: 16px;
		
	}

	.name {
	/**/
	}

	.name:before {
		content: '•'
	}
}

@media (max-width: 411px) {
	.countdown {
		font-size: 3vmax;
	}
}

.pgi{
	height: 0px; padding-bottom: 125%; width: 100%; position: relative;margin-bottom:16px;
}

.find-details /deep/ p{
	margin-top: 0px !important;
	margin-bottom: 0px !important;
}


.do-pr-container .section-description p{
	margin: 0 auto !important;

}




</style>